<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-md-12">
        <h2 class="titulo">{{ title }}</h2>
        <div class="row">
          <div class="col-md-3 col-xs-12">
            <ul class="category-list">
              <li>
                <router-link to="/noticias">
                  Todas
                </router-link>
              </li>
              <li v-for="category in categories">
                <router-link :to="getUrlCategory(category.id, category.name)">
                  {{ category.name }}
                </router-link>
              </li>
            </ul>
          </div>
          <div class="col-md-9 col-xs-12">
            <ul id="blogs">
              <li v-for="item in itemsList">
                <router-link :to="getUrl(item.id, item.name)">
                  <img v-if="item.image" :src="item.image"/>
                  <div class="imagem" v-if="!item.image"><img src="dist/images/sem_imagem.jpg"/></div>
                  <span><i class="fa fa-calendar" aria-hidden="true"></i> {{ item.created_at }}
                    <i class="fa fa-clock-o" aria-hidden="true"></i> {{ item.hour_create_at }}</span>
                  <p>{{ item.name }}</p>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
  import {get} from '../helpers/api';
  import Loading from '../components/common/Loading.vue';
  import {slugify} from '../helpers/slugify';

  export default {
    components: {
      Loading
    },
    data() {
      return {
        showContent: false,
        categories: [],
        news: [],
        title: 'Notícias',
        selectedCategory: 'all'
      }
    },
    created() {
      let self = this;
      get('categories-news').then(function (response) {
        self.categories = response.data.result.data;
      });

      get('news').then(function (response) {
        self.news = response.data.result.data;
        self.showContent = true;
      });
    },
    mounted() {
      if (this.$route.params.categoryId) {
        this.filterItems(this.$route.params.categoryId);
        this.$forceUpdate();
      }
    },
    methods: {
      filterItems(caterogyId) {
        this.selectedCategory = caterogyId;
      },
      getUrl(id, string) {
        return '/noticia/' + id + '/' + slugify(string);
      },
      getUrlCategory(id, string) {
        return '/noticias/' + id + '/' + slugify(string);
      }
    },
    computed: {
      itemsList() {
        if (typeof this.news === 'undefined') {
          return [];
        }

        if (this.selectedCategory === 'all') {
          this.$forceUpdate();
          return this.news;
        }

        return this.news.filter(function (obj) {
          return obj.categoria_id == this.selectedCategory;
        }, this).slice();
      }
    },
    watch: {
      $route(to) {
        if (to.params.categoryId) {
          this.filterItems(to.params.categoryId);
        } else {
          this.filterItems('all');
        }
        this.$forceUpdate();
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/Blog.vue